<script>
import { mapGetters, mapActions } from "vuex";
import genders from "../service/genders";

// import AppAdditionalEduDirs from "../components/AppAdditionalEduDirsAdmin.vue";
import UploadFileAdmin from "./UploadFileAdmin.vue";

export default {
  components: { UploadFileAdmin /*AppAdditionalEduDirs */ },

  props: {
    isReadonly: {
      type: Boolean,
      default: () => false,
    },
  },

  data: () => ({
    isLoading: false,

    isValid: false,

    genders,

    years: Array.from(
      { length: new Date().getFullYear() - 1950 },
      (value, index) => 1951 + index
    ).reverse(),
  }),

  computed: {
    ...mapGetters("admin-application", [
      "GET_APPLICATION",
      "GET_EDUCATION_FACULTYS",
      "GET_EDUCATION_TYPES",
      "GET_EDUCATION_LANGUAGES",
      "GET_SCHOOL_TYPES",
    ]),
    application: (vm) => vm.GET_APPLICATION,
    isStaj: (vm) =>
      vm.application.educationFaculty.id == 4 &&
      vm.application.educationType.id == 3,
    isCert: (vm) =>
      vm.application.foreignLanguageProficiency.id != 1 &&
      vm.application.foreignLanguageProficiency.id != 7 &&
      vm.application.foreignLanguageProficiency.id != 8,
    isOtherCert: (vm) => vm.application.foreignLanguageProficiency.id == 6,
  },

  methods: {
    ...mapActions("admin-application", [
      "INIT_APPLICATION",
      "SET_APPLICATION",
      "SAVE_APPLICATION",
      "INIT_EDUCATION_FACULTYS",
      "INIT_EDUCATION_TYPES",
      "INIT_EDUCATION_LANGUAGES",
    ]),

    onChangeApp() {
      this.$nextTick(() => {
        this.SET_APPLICATION(this.application);
      });
    },

    onChangeEducationFaculty() {
      const params = { id: this.application.educationFaculty.id };
      this.isLoading = true;

      this.application.educationType.id = null;
      this.application.educationLanguage.id = null;
      this.application.additionalFaculty = [];

      this.INIT_EDUCATION_TYPES(params).then(() => {
        this.isLoading = false;
      });
      this.application.educationType.id = null;

      this.onChangeApp();
    },

    onChangeEducationType() {
      const params = {
        typeId: this.application.educationType.id,
        facultyId: this.application.educationFaculty.id,
      };

      this.isLoading = true;

      this.application.educationLanguage.id = null;
      this.application.additionalFaculty = [];

      this.INIT_EDUCATION_LANGUAGES(params).then(() => {
        this.isLoading = false;
      });

      this.application.educationLanguage.id = null;

      this.onChangeApp();
    },

    onChangeEducationLanguage() {
      const id = this.application.educationLanguage.id;
      const langs = this.GET_EDUCATION_LANGUAGES;
      const lang = langs.find((x) => x.language.id == id);

      this.application.additionalFaculty = [];

      if (lang) {
        this.application.scienceComplex = lang.scienceComplex || {};

        const params = {
          scienceComplexId: this.application.scienceComplex.id,
          facultyId: this.application.educationFaculty.id,
          typeId1: this.application.educationType.id,
        };

        this.isLoading = true;

        this.INIT_ADDITIONAL_FACULTIES(params).then(() => {
          this.isLoading = false;
        });

        this.onChangeApp();
      }
    },

    onSend() {
      this.isValid = true;
      this.$refs.form.validate();
      this.$nextTick(() => {
        const el = document.querySelector(".error--text");

        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        } else {
          this.SAVE_APPLICATION(this.application).then((status) => {
            if (status) {
              window.location.reload();
            }
          });
        }
      });
    },

    onChangeScore() {
      const str = this.application.dtmScore || "";
      if (!`${str}`.trim()) this.application.dtmAbiturientNumber = null;
      this.onChangeApp();
    },
  },
};
</script>

<template>
  <v-form
    :readonly="isReadonly"
    @submit.prevent="() => false"
    ref="form"
    lazy-validation
  >
    <div class="py-13 px-6">
      <v-row>
        <v-col cols="12" md="4">
          <div>
            <div class="form-label">
              {{ $t("Name (as in Passport)") }} <span v-text="'*'" />
            </div>

            <v-text-field
              autofocus
              autocomplete="off"
              @blur="onChangeApp"
              v-model="application.firstName"
              dense
              outlined
              required
              :rules="[$rules.text]"
            />
            <div class="position-relative">
              <div
                v-if="application.reviews.firstName && !isReadonly"
                v-text="application.reviews.firstName"
                class="red--text review-msg"
              />
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <div>
            <div class="form-label">
              {{ $t("Last name (as in passport)") }} <span v-text="'*'" />
            </div>
            <v-text-field
              autocomplete="off"
              @blur="onChangeApp"
              v-model="application.lastName"
              dense
              outlined
              required
              :rules="[$rules.text]"
            />
            <div class="position-relative">
              <div
                v-if="application.reviews.lastName && !isReadonly"
                v-text="application.reviews.lastName"
                class="red--text review-msg"
              />
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <div>
            <div class="form-label">
              {{ $t("Father's name (as in the passport)") }}
              <span v-text="'*'" />
            </div>
            <v-text-field
              autocomplete="off"
              @blur="onChangeApp"
              v-model="application.middleName"
              dense
              outlined
              required
              :rules="[$rules.text]"
            />
            <div class="position-relative">
              <div
                v-if="application.reviews.middleName && !isReadonly"
                v-text="application.reviews.middleName"
                class="red--text review-msg"
              />
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <div class="text-center">
            <img src="@/assets/icons/devider.svg" alt="" />
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <div class="accent--text bold--text">
            {{ $t("Passport series and number") }} <span v-text="'*'" />
          </div>
          <v-text-field
            autocomplete="off"
            @blur="onChangeApp"
            v-model="application.passportNumber"
            class="text-field"
            solo
            placeholder="AA1234567"
            required
            :rules="[$rules.passport]"
            v-inputmask="$masks.passport"
          />
          <div class="position-relative">
            <div
              v-if="application.reviews.passportNumber && !isReadonly"
              v-text="application.reviews.passportNumber"
              class="red--text review-msg"
            />
          </div>
          <div class="accent--text bold--text">
            {{ $t("jshir") }} <span v-text="'*'" />
          </div>
          <v-text-field
            autocomplete="off"
            @blur="onChangeApp"
            v-model="application.jshir"
            class="text-field"
            placeholder="12345678912345"
            solo
            required
            :rules="[$rules.jshir12]"
            v-inputmask="$masks.numberLength12"
          />
          <div class="position-relative">
            <div
              v-if="application.reviews.jshir && !isReadonly"
              v-text="application.reviews.jshir"
              class="red--text review-msg"
            />
          </div>
          <div class="accent--text bold--text">
            {{ $t("add phone number") }} <span v-text="'*'" />
          </div>
          <tel-input class="text-field" v-model="application.homePhone" />

          <div class="position-relative">
            <div
              v-if="application.reviews.homePhone && !isReadonly"
              v-text="application.reviews.homePhone"
              class="red--text review-msg"
            />
          </div>
        </v-col>
        <v-col cols="12" md="8">
          <img
            class="align-content-center rasmcenter"
            src="../assets/img/jshr_number.png"
            alt=""
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <div class="text-center">
            <img src="@/assets/icons/devider.svg" alt="" />
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <div class="accent--text bold--text">
            {{ $t("Upload a copy of your passport") }} <span v-text="'*'" />
          </div>

          <div
            v-if="application.reviews.passportPhoto && !isReadonly"
            v-text="application.reviews.passportPhoto"
            class="red--text pb-2"
          />

          <upload-file-admin
            :readonly="isReadonly"
            required
            :isValid="isValid"
            param="passportPhoto"
          />
        </v-col>
        <v-col cols="12" md="6">
          <div class="accent--text bold--text">
            {{ $t("Upload a copy of your passport back") }}
            <span v-text="'*'" />
          </div>

          <div
            v-if="application.reviews.passportBackPhoto && !isReadonly"
            v-text="application.reviews.passportBackPhoto"
            class="red--text pb-2"
          />

          <upload-file-admin
            :readonly="isReadonly"
            required
            :isValid="isValid"
            param="passportBackPhoto"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <div class="text-center">
            <img src="@/assets/icons/devider.svg" alt="" />
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <div class="accent--text bold--text">
            {{ $t("DTM result") }}
          </div>
          <v-text-field
            autocomplete="off"
            @blur="onChangeScore"
            v-model="application.dtmScore"
            class="text-field"
            solo
            clearable
            v-inputmask="$masks.number2"
          />

          <div class="position-relative">
            <div
              v-if="application.reviews.dtmScore && !isReadonly"
              v-text="application.reviews.dtmScore"
              class="red--text review-msg"
            />
          </div>
        </v-col>
        <v-col cols="12" md="6" v-if="application.dtmScore">
          <div class="accent--text bold--text">
            {{ $t("Applicant dtm ID number") }}
            <span v-text="'*'" />
          </div>
          <v-text-field
            autocomplete="off"
            @blur="onChangeApp"
            v-model="application.dtmAbiturientNumber"
            class="text-field"
            placeholder="1234567"
            solo
            required
            :rules="[application.dtmScore ? $rules.dtmid : true]"
            v-inputmask="$masks.numberLength7"
          />

          <div class="position-relative">
            <div
              v-if="application.reviews.dtmAbiturientNumber && !isReadonly"
              v-text="application.reviews.dtmAbiturientNumber"
              class="red--text review-msg"
            />
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <div class="text-center">
            <img src="@/assets/icons/devider.svg" alt="" />
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <div class="accent--text bold--text">
            {{ $t("Choose a field of study") }} <span v-text="'*'" />
          </div>
          <v-autocomplete
            @change="onChangeEducationFaculty"
            :items="GET_EDUCATION_FACULTYS"
            v-model="application.educationFaculty.id"
            item-value="id"
            item-text="name"
            class="text-field"
            solo
            required
            :rules="[$rules.required]"
          />

          <div class="position-relative">
            <div
              v-if="application.reviews.educationFaculty && !isReadonly"
              v-text="application.reviews.educationFaculty"
              class="red--text review-msg"
            />
          </div>
          <div class="accent--text bold--text">
            {{ $t("Choose the type of education") }} <span v-text="'*'" />
          </div>
          <v-select
            item-value="id"
            item-text="name"
            autocomplete="off"
            @change="onChangeEducationType"
            v-model="application.educationType.id"
            class="text-field"
            solo
            required
            :rules="[$rules.required]"
            :items="GET_EDUCATION_TYPES"
          />

          <div class="position-relative">
            <div
              v-if="application.reviews.educationType && !isReadonly"
              v-text="application.reviews.educationType"
              class="red--text review-msg"
            />
          </div>

          <div class="accent--text bold--text">
            {{ $t("Choose the language of instruction") }}
            <span v-text="'*'" />
          </div>
          <v-select
            autocomplete="off"
            item-value="language.id"
            item-text="language.name"
            @change="onChangeEducationLanguage"
            :items="GET_EDUCATION_LANGUAGES"
            v-model="application.educationLanguage.id"
            class="text-field"
            solo
            required
            :rules="[$rules.required]"
          />
          <div class="position-relative">
            <div
              v-if="application.reviews.educationLanguage && !isReadonly"
              v-text="application.reviews.educationLanguage"
              class="red--text review-msg"
            />
          </div>
        </v-col>
        <template v-if="isStaj">
          <v-col cols="12" md="6">
            <div class="accent--text bold--text">
              {{ $t("staj_kiriting") }}
              <span v-if="isCert" v-text="'*'" />
            </div>
            <div class="position-relative">
              <div
                v-if="application.reviews.stajYear && !isReadonly"
                v-text="application.reviews.stajYear"
                class="red--text review-msg"
              />
            </div>
            <v-text-field
              autocomplete="off"
              @blur="onChangeApp"
              v-model="application.stajYear"
              class="text-field"
              solo
              :required="isStaj"
              :disabled="!isStaj"
              :rules="[isStaj ? $rules.required : true]"
              v-inputmask="$masks.number"
            />

            <div class="accent--text bold--text">
              {{ $t("staj_rasm") }}
              <span v-if="isStaj" v-text="'*'" />
            </div>
            <div
              v-if="application.reviews.stajPhoto && !isReadonly"
              v-text="application.reviews.stajPhoto"
              class="red--text review-msg"
            />

            <upload-file-admin
              :viewHeight="'60%'"
              :readonly="isReadonly"
              :required="isStaj"
              :isValid="isValid"
              param="stajPhoto"
            />
          </v-col>
        </template>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <div class="text-center">
            <img src="@/assets/icons/devider.svg" alt="" />
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="row">
      <div align="center" class="col-12">
        <v-btn :disabled="isReadonly" @click="onSend" color="accent">
          {{ $t("Save") }}
        </v-btn>
      </div>
    </div>
  </v-form>
</template>

<style lang="scss" scoped>
.section-header {
  background: rgb(0, 150, 219);
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.25em;
  color: white;
  padding: 5px;
}

.form-label {
  font-weight: 500;
  margin-bottom: 8px;

  span {
    padding-left: 2px;
    color: red;
  }
}

.review-msg {
  position: absolute;
  top: -26px;
}

.photo-margin {
  margin-left: 50px;
}

/* ── Dark Mode ── */
.theme--dark .form-label {
  color: #d5d6de !important;
}

.theme--dark .section-header {
  background: rgb(0, 120, 180) !important;
}
</style>
